import { render, staticRenderFns } from "./CatalogsDetail.vue?vue&type=template&id=4f552c53&"
import script from "./CatalogsDetail.vue?vue&type=script&lang=js&"
export * from "./CatalogsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports